module.exports = __webpack_public_path__ + "img/lb.863cbd43.png";